import { z } from "zod";

export const ZATCA_OTP_SCHEMA = z.object({
  otp: z
    .string()
    .min(1, { message: "errors.otp_required" })
    .refine((val) => val.length === 6 && /^\d+$/.test(val), {
      message: "errors.otp_format",
    }),
});

export const ZATCA_COUNTER_SCHEMA = z.object({
  lastSubmittedInvoiceHash: z
    .string()
    .transform((val) => (val === "" ? null : val))
    .nullable()
    .optional(),
  invoiceCounterNumber: z
    .union([
      z
        .string()
        .transform((val) => (val === "" ? null : Number(val)))
        .refine((val) => val === null || (!isNaN(val) && val > 0), {
          message: "errors.invalid_counter",
        }),
      z
        .number()
        .nullable()
        .refine((val) => val === null || val > 0, {
          message: "errors.invalid_counter",
        }),
    ])
    .nullable()
    .optional(),
});
